import React from 'react';
import { getIndicesformFields } from '../utilities/form-utilities';
import SPGVariables from '../../../utilities/spg-variables';
import APIManager from '../../../utilities/api-manager';
import { constructRATEmail } from '../../../utilities/construct-email';
import { getText } from '../../../helpers';

const RequestTrialForm = React.lazy(() => import('../index' /* webpackChunkName: "request-a-trial-form" */));

const formText = getText('pages.requestTrial');
const spgVariables = SPGVariables();
function getMailingList(variant: string): string {
    if (variant === 'index') {
        return spgVariables.INDEXRATEMAILLIST;
    }
    if (variant === 'ratings') {
        return spgVariables.RATINGSRATEMAILLIST;
    }
    if (variant === 'spglobal') {
        return spgVariables.SPGLOBALRATEMAILLIST;
    }
    if (variant === 'coalition') {
        return spgVariables.COALITIONEMAILLIST;
    }
    if (variant === 'mobility') {
        return spgVariables.MOBILITYEMAILLIST;
    }

    return '';
}

const emailStatusCallback = (hasRequestSuccess: boolean, successCallback: () => void, error: (error: string) => void) => {
    if (hasRequestSuccess) {
        successCallback();
    } else {
        error('Marketo request  failed');
    }
};

function RequestTrialEmail(props: RequestATrialFormProps) {
    const { productName = '', productVariant, variant = '', titleText, ratVariant } = props;
    const onSubmit = (data: RequestATrialState, cb: () => void, error: (error: string) => void) => {
        APIManager.sendEmail(
            constructRATEmail(productName, data),
            formText.emailSubject.replace('{productName}', productName),
            getMailingList(variant),
            (isSuccess: boolean) => {
                emailStatusCallback(isSuccess, cb, error);
            }
        );
    };
    return <RequestTrialForm onSubmitForm={onSubmit} formTextFields={getIndicesformFields()} productVariant={productVariant} titleText={titleText} ratVariant={ratVariant} />;
}

export default React.memo(RequestTrialEmail);
